import { useEffect } from 'react'

import { resizeMessageType } from './constants'

const postHeight = () => {
  window.parent.postMessage(
    {
      type: resizeMessageType,
      payload: { height: Math.ceil(document.documentElement.getBoundingClientRect().height) },
    },
    '*'
  )
}

const useIframeResize = isEmbedded => {
  useEffect(() => {
    if (!isEmbedded || window.parent === window) return

    const root = document.documentElement
    const resizeObserver = new ResizeObserver(postHeight)

    root.style.overflow = 'hidden'
    resizeObserver.observe(root)

    return () => {
      resizeObserver.disconnect()
      root.style.removeProperty('overflow')
    }
  }, [isEmbedded])
}

export default useIframeResize
